/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './referencelistoptout.defs.js'
export { main as default } from './referencelistoptout.defs.js'
